module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_03-7666295324d2174e92b5f8b1f6e901c1.svg";